export class VatInstance {
  code = '';
  name = '';

  constructor(vat) {
    this.name = vat.vatApplied;
    this.code = vat.companyLocalVATCode;
  }
}
